import { IconImage } from 'bold-ui'
import { blue, gray, orange, pink, purple, turquoise } from 'bold-ui/lib/styles/colors'
import { MapMarker } from 'components/map/MapMarker'
import { TipoImovelEnum } from 'graphql/types.generated'
import { useHistory, useRouteMatch } from 'react-router'

import { PINO_TERRITORIO_MODAL_ROUTE, TerritorioPinoModel } from '../model-territorioMapa'
import { MapaTerritorioMarkerCard } from './MapaTerritorioMarkerCard'
import { MapaTerritorioMarkerHover } from './MapaTerritorioMarkerHover'

interface MapaTerritorioMarkerProps {
  imovel: TerritorioPinoModel
}

export function MapaTerritorioMarker(props: Readonly<MapaTerritorioMarkerProps>) {
  const { imovel } = props
  const tipoImovel = imovel.tipoImovel ?? TipoImovelEnum.OUTROS

  const { icon, color } = TIPO_IMOVEL_MARKER_CONFIG[tipoImovel]
  const { url } = useRouteMatch()
  const history = useHistory()

  const handleClick = () => history.push(`${url}/${PINO_TERRITORIO_MODAL_ROUTE}/${imovel.id}`)

  return (
    <MapaTerritorioMarkerHover
      hoverContent={<MapaTerritorioMarkerCard imovel={imovel} />}
      tooltipId={`mapa-territorio-marker-tooltip-${imovel.id}`}
    >
      <MapMarker icon={icon} color={color} label='Visualizar detalhes do imóvel' onClick={handleClick} />
    </MapaTerritorioMarkerHover>
  )
}

interface TipoImovelPinoConfig {
  icon: IconImage
  color?: string
}

const TIPO_IMOVEL_MARKER_CONFIG: Record<TipoImovelEnum, TipoImovelPinoConfig> = {
  [TipoImovelEnum.INSTITUICAO_LONGA_PERMANENCIA_PARA_IDOSOS]: { icon: 'sixtyPlus', color: pink.c40 },
  [TipoImovelEnum.ABRIGO]: { icon: 'shieldFilled', color: pink.c40 }, // falta adicionar icon no bold
  [TipoImovelEnum.DOMICILIO]: { icon: 'houseFilled', color: blue.c60 },
  [TipoImovelEnum.PONTO_ESTRATEGICO]: { icon: 'pinFilled', color: orange.c60 },
  [TipoImovelEnum.ESTABELECIMENTO_RELIGIOSO]: { icon: 'candle', color: orange.c60 },
  [TipoImovelEnum.COMERCIO]: { icon: 'bag', color: orange.c60 },
  [TipoImovelEnum.UNIDADE_MEDIDA_SOCIOEDUCATIVA]: { icon: 'target', color: blue.c20 },
  [TipoImovelEnum.UNIDADE_PRISIONAL]: { icon: 'prison', color: blue.c20 },
  [TipoImovelEnum.DELEGACIA]: { icon: 'shieldFilled', color: blue.c20 }, // falta adicionar icon no bold
  [TipoImovelEnum.TERRENO_BALDIO]: { icon: 'fence', color: purple.c60 },
  [TipoImovelEnum.ESCOLA]: { icon: 'graduateCap', color: turquoise.c60 },
  [TipoImovelEnum.CRECHE]: { icon: 'teddyBear', color: turquoise.c60 },
  [TipoImovelEnum.OUTROS]: { icon: 'mapMarkerFilled', color: gray.c20 }, // falta adicionar icon no bold
  [TipoImovelEnum.CASAI]: { icon: 'houseFilled', color: gray.c20 }, // falta adicionar icon no bold
}
